/**
 * 평가결과 본문 테이블 매핑 (`ResultBody`에서 호출)
 * 우선순위: CONTENT_CODE_RESULT_VIEW(프로젝트 오버라이드) → resolveResultViewFromContentCode(old_scenario_data 시트+보조규칙) → 시나리오 resultViewType → 클래스 category
 */
import {
  OLD_SCENARIO_DATA_CONTENT_CODE_TO_VIEW,
  resolveResultViewFromContentCode,
  type ResultViewType,
} from '@/constants/scenarioTypes';
import type { ClassCategory } from './layout';

/**
 * 시트 매핑 + 필요 시만 여기에 키를 덮어씀.
 * @see OLD_SCENARIO_DATA_CONTENT_CODE_TO_VIEW — [old_scenario_data gid=2055225077](https://docs.google.com/spreadsheets/d/1kJc2ljIZpu3KWdbBuGf7SQTNKVLK9Tp9MyTPOuBg4lU/edit?gid=2055225077)
 */
export const CONTENT_CODE_RESULT_VIEW: Record<string, ResultViewType> = {
  ...OLD_SCENARIO_DATA_CONTENT_CODE_TO_VIEW,
};

/**
 * [메디크루 플랫폼 콘텐츠관리](https://docs.google.com/spreadsheets/d/1kJc2ljIZpu3KWdbBuGf7SQTNKVLK9Tp9MyTPOuBg4lU) `old_scenario_data` F열 result_view 신규 명칭 → 앱 ResultViewType
 */
const OLD_SCENARIO_DATA_RESULT_VIEW_MAP: Record<string, ResultViewType> = {
  TriageResult: 'TriageView',
  AssessmentResult: 'NeurologicalBundleView',
  ProcedureResult: 'ProcedureView',
  ProcedureView: 'ProcedureView',
  EvaluationTable: 'EvaluationTable',
};

export function getResultViewTypeByContentCode(
  contentCode: string | undefined | null,
): ResultViewType | undefined {
  if (contentCode == null || String(contentCode).trim() === '') return undefined;
  const key = String(contentCode).trim();
  const manual = CONTENT_CODE_RESULT_VIEW[key];
  if (manual) return manual;
  return resolveResultViewFromContentCode(key);
}

export function normalizeResultViewTypeFromScenario(
  raw: string | undefined | null,
): ResultViewType | undefined {
  if (raw == null || String(raw).trim() === '') return undefined;
  const s = String(raw).trim();
  const fromSheetName = OLD_SCENARIO_DATA_RESULT_VIEW_MAP[s];
  if (fromSheetName) return fromSheetName;
  if (s === 'AssesmentView') return 'NeurologicalBundleView';
  const known: ResultViewType[] = [
    'TriageView',
    'NeurologicalBundleView',
    'GcsResult',
    'PupilResult',
    'MotorResult',
    'ProcedureView',
    'EvaluationTable',
  ];
  if (known.includes(s as ResultViewType)) {
    return s as ResultViewType;
  }
  return undefined;
}

export function resolveSessionResultTableView(input: {
  contentCode?: string | null;
  resultViewType?: string | null;
  classCategory?: ClassCategory;
}): ResultViewType {
  const { contentCode, resultViewType, classCategory } = input;

  const fromContent = getResultViewTypeByContentCode(contentCode ?? undefined);
  if (fromContent) return fromContent;

  const fromSheet = normalizeResultViewTypeFromScenario(resultViewType ?? undefined);
  if (fromSheet) return fromSheet;

  if (classCategory === 'triage') return 'TriageView';

  return 'ProcedureView';
}
